<template>
  <div>
    <div class="reference title">
      {{ reference }}
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed: {
      reference() {
        return !this.$store.getters.cartReference ? '' : this.$store.getters.cartReference
      }
    }
  }
</script>

<style lang="scss" scoped>
  .material-title-edit {
    color: $light-grey;
    cursor: pointer;
    font-size: 0.5em;
    padding-left: 5px;
  }
</style>
